import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=165c23ed&scoped=true&"
import script from "./Media.vue?vue&type=script&lang=js&"
export * from "./Media.vue?vue&type=script&lang=js&"
import style0 from "./Media.vue?vue&type=style&index=0&id=165c23ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c23ed",
  null
  
)

component.options.__file = "Media.vue"
export default component.exports